import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { CreateRequestPayload } from '../../../utils/request';

export abstract class TagsManagerBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract removeGzTagRecords(payload: CreateRequestPayload['payload'], allSelected: boolean): Promise<object>;
}
